import { configureStore, isPlain } from '@reduxjs/toolkit';
// import logger from 'redux-logger';
import rootDisplayReducer from './rootReducer';
import { useDispatch } from 'react-redux';
// the condition will decide whether throw error of non-serializable value
const isSerializable = (value: any) => value instanceof Date || isPlain(value);

const isProduction = process.env.NODE_ENV === 'production';
const showLogger = localStorage.getItem('show-logger') === "true" ? true : false;

// const floorplanMiddleware = ({ dispatch, getState }: any) => (next: any) => (action: any) => {
//   console.log('action', action)
//   if (action.type === "bookings/updateFloorplanBookings") {
//     action(dispatch, getState);
//   }
//   else {
//     next(action);
//   }
// };


const store = configureStore({
  reducer: rootDisplayReducer,
  middleware: (getDefaultMiddleware) => {
    // const defaultMiddleware = getDefaultMiddleware({
    //   serializableCheck: { isSerializable },
    // });
    const defaultMiddleware = getDefaultMiddleware({
      thunk: true,
      serializableCheck: false,
      immutableCheck: true
    });

    // defaultMiddleware.push(floorplanMiddleware);

    // @ts-ignore
    return defaultMiddleware;
    // return (isProduction || !showLogger) ? defaultMiddleware : defaultMiddleware.concat(logger);
  },
  devTools: !isProduction,
});

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

if (!isProduction && module.hot) {
  module.hot.accept('./rootReducer', () => store.replaceReducer(rootDisplayReducer));
}

export default store;
